'use client';
import { useGetMyBookingsQuery } from '@/hook/slices/user-bookings-slice';
import useAuth from '@/hook/use-auth.hook';
import styles from './styles.module.scss';
import {
    BookingArrowDown,
    BookingArrowUp,
    NoBuyingRequests,
} from 'public/Images';
import { useTranslation } from '@/hook';
import Button from '@/components/shared/Button/button.component';
import { useRouter } from 'next/navigation';
import NoItemsFoundProfile from './no-items/no-items.component';
import Typography from '@/components/shared/typography/typography.component';
import colors from '@/theme/colors.module.scss';
import Spinner from '@/components/Spin/Spinner';
import {
    CardStatusTypes,
    CustomerBookingWIthSellingOpp,
    RetailBookingStatus,
} from '@/types';
import BookingCardWrapper from './upload-payments/bookings-card/bookings-card.wrapper';
import { useEffect, useState } from 'react';
import Image from 'next/image';
import { useDispatch } from 'react-redux';
import { setRedirectUrl } from '@/redux/reducers/auth.reducer';
import { ChevronLeftBlack } from 'public/Images/CustomerProfile';

export default function MyBookingsRequests() {
    const router = useRouter();
    const { i18n, t } = useTranslation();
    const dispatch = useDispatch();
    const { userId } = useAuth();
    const { data, isLoading } = useGetMyBookingsQuery({ userId });

    const [activeBookings, setActiveBookings] = useState<
        CustomerBookingWIthSellingOpp[]
    >([]);
    const [inactiveBookings, setInactiveBookings] = useState<
        CustomerBookingWIthSellingOpp[]
    >([]);
    const [openDropdown, setOpenDropdown] = useState(false);
    const [allInactive, setAllInactive] = useState(true);
    const numberToShowIfAllInactive = 2;
    const unBookingsData = data?.data as unknown;
    const bookingsData = unBookingsData as CustomerBookingWIthSellingOpp[];

    const lang = i18n.language;
    useEffect(() => {
        if (!userId) {
            dispatch(setRedirectUrl('account/mybookings'));
            router.push(`/${lang}/register`);
        }
    }, [userId]);

    const isInActive = (booking: CustomerBookingWIthSellingOpp) => {
        const isSellingOpportunity = booking.sellingOpportunity;
        const status = isSellingOpportunity
            ? booking.sellingOpportunity?.sellingOpportunityStatus
            : booking.bookingStatus;

        const isInactive = isSellingOpportunity
            ? status === CardStatusTypes.CANCELED ||
              status === CardStatusTypes.RETURNED ||
              status === CardStatusTypes.PURCHASED
            : status === RetailBookingStatus.Canceled ||
              status === RetailBookingStatus.ClosedFailure ||
              status === RetailBookingStatus.NoShow ||
              status === RetailBookingStatus.ClosedSuccess;
        return isInactive;
    };
    useEffect(() => {
        if (!bookingsData) return;
        const { active, inactive } = bookingsData.reduce(
            (
                acc: {
                    active: CustomerBookingWIthSellingOpp[];
                    inactive: CustomerBookingWIthSellingOpp[];
                },
                booking
            ) => {
                const isActive = !isInActive(booking);

                if (isActive) {
                    acc.active.push(booking);
                } else {
                    booking.sellingOpportunity?.sellingOpportunityStatus ===
                    CardStatusTypes.PURCHASED
                        ? acc.inactive.unshift(booking)
                        : acc.inactive.push(booking);
                }

                return acc;
            },
            {
                active: [],
                inactive: [],
            }
        );

        setAllInactive(active.length === 0);
        setActiveBookings(active);
        setInactiveBookings(inactive);
    }, [bookingsData]);

    return (
        <div className={styles.pageContainer}>
            {isLoading ? (
                <Spinner />
            ) : (
                <div>
                    <div className="flex justify-center items-center relative border-b border-b-gray-200 px-[5%] pt-0 pb-4 md:hidden">
                        <div
                            className="en:left-[20px] ar:right-[20px] absolute"
                            onClick={() => router.push(`/${lang}/account`)}
                        >
                            <Image
                                src={ChevronLeftBlack}
                                alt="ChevronLeftBlack"
                                width="8"
                                height="20"
                                className="ar:scale-[-1]"
                            />
                        </div>
                        <div>
                            <Typography
                                variant="body1Medium"
                                className="!text-gray-800"
                            >
                                {t('MyBuyingRequests')}
                            </Typography>
                        </div>
                    </div>
                    {bookingsData?.length ? (
                        <div className="px-4 pb-4 md:pb-0 md:px-0">
                            <div className="mt-4 hidden md:block">
                                <Typography
                                    variant="h6"
                                    className="mb-6 !font-semibold text-gray-800"
                                    component="span"
                                >
                                    {t('MyBuyingRequests')}
                                </Typography>
                            </div>
                            <div className="md:grid gap-4 md:grid-cols-3 hidden ">
                                {activeBookings.map(item => {
                                    const vehicleStatus = item.vehicle.status;
                                    return (
                                        <div
                                            key={`${item.id} ${vehicleStatus}`}
                                        >
                                            <BookingCardWrapper
                                                cantBeClickedByDefault={null}
                                                data={item}
                                            />
                                        </div>
                                    );
                                })}{' '}
                                {inactiveBookings.map(item => {
                                    const vehicleStatus = item.vehicle.status;
                                    return (
                                        <div
                                            key={`${item.id} ${vehicleStatus}`}
                                        >
                                            <BookingCardWrapper
                                                cantBeClickedByDefault={null}
                                                data={item}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="md:hidden grid gap-4 grid-cols-1 mt-4 md:mt-0">
                                {activeBookings.map(item => {
                                    const vehicleStatus = item.vehicle.status;
                                    return (
                                        <div
                                            key={`${item.id} ${vehicleStatus}`}
                                        >
                                            <BookingCardWrapper
                                                cantBeClickedByDefault={null}
                                                data={item}
                                            />
                                        </div>
                                    );
                                })}
                                {openDropdown &&
                                    !allInactive &&
                                    inactiveBookings.map(item => {
                                        const vehicleStatus =
                                            item.vehicle.status;
                                        return (
                                            <div
                                                key={`${item.id} ${vehicleStatus}`}
                                            >
                                                <BookingCardWrapper
                                                    cantBeClickedByDefault={
                                                        null
                                                    }
                                                    data={item}
                                                />
                                            </div>
                                        );
                                    })}
                                {allInactive &&
                                    inactiveBookings
                                        .slice(0, numberToShowIfAllInactive)
                                        .map(item => {
                                            const vehicleStatus =
                                                item.vehicle.status;
                                            return (
                                                <div
                                                    key={`${item.id} ${vehicleStatus}`}
                                                >
                                                    <BookingCardWrapper
                                                        cantBeClickedByDefault={
                                                            null
                                                        }
                                                        data={item}
                                                    />
                                                </div>
                                            );
                                        })}
                                {openDropdown &&
                                    allInactive &&
                                    inactiveBookings
                                        .slice(
                                            numberToShowIfAllInactive,
                                            inactiveBookings.length
                                        )
                                        .map(item => {
                                            const vehicleStatus =
                                                item.vehicle.status;
                                            return (
                                                <div
                                                    key={`${item.id} ${vehicleStatus}`}
                                                >
                                                    <BookingCardWrapper
                                                        cantBeClickedByDefault={
                                                            null
                                                        }
                                                        data={item}
                                                    />
                                                </div>
                                            );
                                        })}
                                {((inactiveBookings.length > 0 &&
                                    !allInactive) ||
                                    inactiveBookings.length >
                                        numberToShowIfAllInactive) && (
                                    <Button
                                        className="!h-10 !bg-white border !border-gray-300 flex items-center justify-center gap-2"
                                        onClick={() => {
                                            setOpenDropdown(!openDropdown);
                                            if (openDropdown) {
                                                setTimeout(() => {
                                                    window.scroll(0, 0);
                                                }, 300);
                                            }
                                        }}
                                    >
                                        <Image
                                            width={15}
                                            src={
                                                !openDropdown
                                                    ? BookingArrowUp
                                                    : BookingArrowDown
                                            }
                                            alt="arrow down"
                                        />
                                        <Typography
                                            variant="body2Medium"
                                            className="!text-gray-700"
                                        >
                                            {!openDropdown && !allInactive
                                                ? `${t('show')} ${
                                                      inactiveBookings.length
                                                  } ${t('more')}`
                                                : !openDropdown && allInactive
                                                ? `${t('show')} ${
                                                      inactiveBookings.length -
                                                      numberToShowIfAllInactive
                                                  } ${t('more')}`
                                                : t('showLess')}
                                        </Typography>
                                    </Button>
                                )}
                            </div>
                        </div>
                    ) : (
                        <div className={styles.noItemsFoundContainer}>
                            <NoItemsFoundProfile
                                image={NoBuyingRequests}
                                title={t('noBookedCarsTitle')}
                                button={
                                    <Button
                                        className="!w-auto !font-medium"
                                        onClick={() =>
                                            router.push(
                                                `/${i18n.language}/buy-used-cars`
                                            )
                                        }
                                    >
                                        {t('exploreSylndrCars')}
                                    </Button>
                                }
                            >
                                <div className={styles.subtitleContainer}>
                                    <Typography
                                        variant="body2"
                                        color={colors.gray600}
                                        component="div"
                                        className="text-center"
                                    >
                                        {t('noBookedCarsSubtitle1')}
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color={colors.gray600}
                                        component="div"
                                        className="text-center"
                                    >
                                        {t('noBookedCarsSubtitle2')}
                                    </Typography>
                                </div>
                            </NoItemsFoundProfile>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
